import ApiService from '@/services/apiService'

const state = {
	options: [],
	selectedID: null
}

const getters = {
	options: state => state.options,
	selectedID: state => state.selectedID
}

const mutations = {
	storeAircraftOptions: (state, payload) => state.options = payload,
	storeSelectedID: (state, payload) => state.selectedID = payload,
	clearOptions: (state) => state.options = [],
	clearSelected: (state) => state.selectedID = null
}

const actions = {
	/**
	 * Query helicopters from API based on uuid
	 */
	fetchHelicopters({ commit }, uuid) {
		ApiService.get(`bookings/get-tiers/${uuid}`)
			.then(response => {
				if (response.status === 200)
					commit('storeAircraftOptions', response.data)
			})
			.catch(function (error) { console.log(error) })
			.then(() => commit('bookingForm/setStepLoading', null, { root: true }))
	},

	/**
	 * Add the selected helicopter to the current booking.
	 */
	addHelicopterToBooking({ commit, rootState, dispatch }, craftID) {
		let uuid = rootState.bookingForm.uuid

		commit('storeSelectedID', craftID)

		ApiService.get(`bookings/step-two/${uuid}/${craftID}`)
			.then(response => {
				if (response.status === 200) {
					dispatch('summary/fetchSummary', null, { root: true })
				}
			})
			.catch(response => console.log(response))
	},

	/**
	 * Reset all state back to intitial
	 */
	clearState({ commit }) {
		commit('clearOptions')
		commit('clearSelected')
	}
}

export default { namespaced: true, state, getters, mutations, actions }
